// Central product catalog. Add/edit products here, listing + detail pages read from this.
export const PRODUCTS = [
  {
    slug: "picture-day-system",
    packageId: "picture-day-system",
    paymentLink: "https://buy.stripe.com/00wbJ203R90maKccdq1Nu00",
    name: "The I Missed Picture Day System",
    tagline: "Start here",
    price: 29,
    available: true,
    cover: "/images/systems-not-memory.webp",
    shortDesc:
      "A simple step-by-step system for organizing school communication, tracking events, and reducing parent stress.",
    longDesc:
      "The foundational system for getting on top of elementary school life. Set up one home for every date, contact, form, and login, then keep it current in minutes a week.",
    included: [
      "The full guide (screen + print versions)",
      "All templates in fillable + printable formats",
      "Step-by-step setup guide (read in 15 minutes)",
      "Done-for-you family calendar starter",
      "Free lifetime updates",
    ],
    inside: [
      "School Information Dashboard",
      "Family Calendar Setup Checklist",
      "School App Organization Planner",
      "Teacher Contact Tracker",
      "Volunteer & Fundraiser Tracker",
      "School Year Command Center",
      "Parent Radar Check",
    ],
    samples: [
      "/images/products/picture-day/1.png",
      "/images/products/picture-day/2.png",
      "/images/products/picture-day/3.png",
      "/images/products/picture-day/4.png",
    ],
  },
  {
    slug: "elementary-school-command-center",
    packageId: "elementary-school-command-center",
    paymentLink: "https://buy.stripe.com/6oUbJ26sf4K6cSkgtG1Nu01",
    name: "Elementary School Command Center",
    tagline: "Level up",
    price: 37,
    available: true,
    cover: "/images/command-center.webp",
    shortDesc:
      "A complete operating system for school life: calendars, teacher contacts, communication workflows, and more.",
    longDesc:
      "The next step after the Picture Day System. A full workbook plus plug-and-play templates for running the whole school year from one calm home base.",
    included: [
      "The full workbook (screen + print versions)",
      "All templates in fillable + printable formats",
      "Companion to The I Missed Picture Day System",
      "Free lifetime updates",
    ],
    inside: [
      "Year-at-a-glance command dashboard",
      "Teacher & staff contact system",
      "Communication workflow templates",
      "Calendar + reminder framework",
      "Activity & commitment trackers",
    ],
    samples: [
      "/images/products/command-center/1.png",
      "/images/products/command-center/2.png",
      "/images/products/command-center/3.png",
    ],
  },
  {
    slug: "elementary-school-survival-kit",
    packageId: "elementary-school-survival-kit",
    paymentLink: "https://buy.stripe.com/dRm3cw17V1xU8C4gtG1Nu02",
    name: "Elementary School Survival Kit",
    tagline: "Ride the school year",
    price: 37,
    available: true,
    cover: "/images/survival-kit.webp",
    shortDesc:
      "A seasonal toolkit that follows the actual rhythm of the school year, including the parts that catch parents off guard.",
    longDesc:
      "Season-by-season support from the first-day scramble through end-of-year chaos. Know what's coming each part of the year and walk in prepared.",
    included: [
      "The seasonal guide (screen + print versions)",
      "All templates in fillable + printable formats",
      "Season-by-season playbook: fall through spring",
      "Free lifetime updates",
    ],
    inside: [
      "Fall / back-to-school launch plan",
      "Winter & holiday-season checklists",
      "Spring wrap-up & transition guide",
      "Seasonal supply + event trackers",
    ],
    samples: [
      "/images/products/survival-kit/1.png",
      "/images/products/survival-kit/2.png",
      "/images/products/survival-kit/3.png",
    ],
  },
];

export const COMING_SOON = [
  {
    name: "Executive Function Toolkit for Parents",
    price: "$47–$97",
    desc: "Why the tools keep failing, and how to build systems that match how the brain actually works under stress.",
    flagship: false,
  },
  {
    name: "Family Operations Manual",
    price: "$97–$197",
    desc: "The complete family operating system. You've been running a complex operation without a manual. This is it.",
    flagship: true,
  },
  {
    name: "ADHD-Friendly Family Systems",
    price: "$97–$297",
    desc: "Built for families where ADHD is part of the picture, whether it's the parent, the child, or both.",
    flagship: false,
  },
  {
    name: "The Parent Reset Membership",
    price: "$15–$29 / month",
    desc: "Never feel behind on school life again. Every month, you'll know exactly what's coming and how to stay ahead of it.",
    flagship: false,
  },
];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);
